import { ProjectAssetEnum } from 'api/enums';

export const ProjectAssets = [
    {
        content: 'TimeLapse',
        to: 'cameras',
        identifier: ProjectAssetEnum.TIMELAPSE,
    },
    {
        content: 'Live Cameras',
        to: 'live-cameras',
        identifier: ProjectAssetEnum.CAMERA_CCTV,
    },
    {
        content: 'Drone Footage',
        to: 'drones',
        identifier: ProjectAssetEnum.DRONE_FOOTAGE,
    },
    {
        content: 'SiteWalk',
        to: 'floor-plans',
        identifier: ProjectAssetEnum.SITE_WALK,
    },
    {
        content: 'Site Gallery',
        to: 'site-gallery',
        identifier: ProjectAssetEnum.SITE_GALLERY,
    },
    {
        content: 'Equipment Trackers',
        to: 'equipment-trackers',
        identifier: ProjectAssetEnum.EQUIPMENT_TRACKERS,
    },
    {
        content: 'Links',
        to: 'links',
        identifier: ProjectAssetEnum.PROJECT_LINKS,
    },
];
